// ──────────────────────────────────────────────────────────────
// 혜택 매칭 핵심 규칙 — 단일 진실 공급원(single source of truth)
//
// 화면(App.js)과 회귀 테스트(scripts/test-match.js)가 "같은 함수"를 씁니다.
//
// 이 두 규칙은 가득에서 가장 아팠던 반복 버그의 진원지라 모듈로 분리 + 테스트로 박제:
//   · 서초구 혜택이 성동구 사용자에게 노출(데이터 누출) — 3회 반복
//   · 동명이구(서울 중구 vs 부산 중구 등) 혼선
//   · '아빠 육아휴직 장려금'이 엄마만 휴직한 가구에 노출
// (2026-06-18 모듈화 2단계)
// ──────────────────────────────────────────────────────────────

// 지역 매칭 — 혜택 b가 사용자 u의 거주지에 해당하는가?
// - b.reg 없음        → 지역 무관 혜택(전국) → 항상 true
// - b.regCity 있음    → 동명이구 방지용 복합키. 시·도(city)까지 일치해야 함
// - 그 외             → b.reg가 사용자의 시·도(city) 또는 시·군·구(district)와 일치
function regMatch(b, u) {
  if (!b || !b.reg) return true;        // 지역 무관 혜택
  if (!u) return true;                  // 사용자 없음 → 지역 필터 안 함(호출부 !u|| 패턴과 동일)
  if (b.regCity && b.regCity !== u.city) return false; // 복합키 시·도 불일치 차단(동명이구 누출 방지)
  return b.reg === u.city || b.reg === u.district;
}

// 아빠(남성)가 육아휴직 중인가? — 지자체 '아빠 육아휴직 장려금' 매칭용.
// 엄마만 휴직한 가구엔 노출되면 안 됨.
//   · both                       → 둘 다 휴직 → true
//   · self + 본인이 남성          → 아빠 본인 휴직 → true
//   · spouse + 본인이 여성        → 배우자(=남편) 휴직 → true
function dadLeave(u) {
  if (!u) return false;
  return u.parentalLeave === "both" ||
    (u.parentalLeave === "self" && u.gender === "male") ||
    (u.parentalLeave === "spouse" && u.gender === "female");
}

module.exports = { regMatch, dadLeave };
